import * as React from 'react';
import { TextFieldWidget } from '@tableau/widgets';
import { ReactActionDialogBodyProps } from './ReactActionDialog';

export type ActionDialogBodyWithTextInputProps = {
  readonly label: string;
  readonly maxLength: number;
}

export type ActionDialogBodyWithTextInputState = {
  readonly text: string;
  readonly errorMessage?: string;
}

const ZERO_WIDTH_SPACE = '\u200B';

export function ActionDialogBodyWithTextInput(
  props: ReactActionDialogBodyProps<ActionDialogBodyWithTextInputProps, ActionDialogBodyWithTextInputState>
): JSX.Element {

  const onChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newText = e.target.value.substring(0, props.maxLength);
      props.updateDialogState({ errorMessage: undefined, text: newText });
    },
    [props.updateDialogState]
  );

  const handleEnterKey = React.useCallback((e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
        props.doAction();
      }
    },
    [props.doAction]
  );

  /* eslint-disable jsx-a11y/no-static-element-interactions */
  return (
    <>
      <div className='tb-dialog-body-input' onKeyDown={handleEnterKey}>
        <TextFieldWidget
          className='tb-full-width'
          style={{ width: '100%' }}
          kind='outline'
          label={props.label}
          maxLength={props.maxLength}
          message={props.dialogState.errorMessage || ZERO_WIDTH_SPACE}
          value={props.dialogState.text}
          onChange={onChange}
          disabled={props.actionBusy}
          valid={props.dialogState.errorMessage ? false : undefined}
          testId={ActionDialogInputTestId}
        />
      </div>
    </>
  );
}

export const ActionDialogInputTestId = 'confirm-action-dialog-input-text-box';
